// extracted by mini-css-extract-plugin
export default {"content":"Partnership_content__QhorR","img2":"Partnership_img2__k86Oc","img1":"Partnership_img1__EvLZG"};